export function matchesStopId(
    entityStopId: string | undefined,
    stopId: string | undefined,
    stopCode?: string | undefined
): boolean {
    if (!entityStopId) {
        return false;
    }

    if (entityStopId === stopId || entityStopId === stopCode) {
        return true;
    }

    if (matchesGotlandStopId(entityStopId, stopId)) {
        return true;
    }

    const entityStopIdWithoutSuffix = entityStopId.replace(/:0$/, '');
    if (stopId === entityStopIdWithoutSuffix || stopCode === entityStopIdWithoutSuffix) {
        return true;
    }

    return entityStopId === stopId + ':0' || entityStopId === stopCode + ':0';
}

/**
 * Gotland stops API inconsistency workaround:
 *
 * In query responses, stop IDs are returned as `Quay` (e.g. NETEX:9:Quay:331-A),
 * while alerts for disrupted stops use `StopPlace` IDs (e.g. NETEX:9:StopPlace:331).
 *
 * To correctly match alerts with stops, we:
 * 1. Replace `:Quay:` with `:StopPlace:`
 * 2. Remove optional quay suffixes (e.g. -A, -B, etc.)
 *
 * This normalizes the ID format so we can compare it with the alert's StopPlace ID.
 */
function normalizeGotlandStopId(id: string): string {
    return id.replace(':Quay:', ':StopPlace:').replace(/-\w+$/, '');
}

function matchesGotlandStopId(entityStopId: string, stopId?: string): boolean {
    if (!stopId) {
        return false;
    }

    return normalizeGotlandStopId(stopId) === entityStopId;
}
